import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from './store/authStore';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import Lessons from './pages/Lessons';
import LessonDetail from './pages/LessonDetail';
import Profile from './pages/Profile';
import Home from './pages/Home';
import LetterPractice from './pages/LetterPractice';
import LetterSounds from './pages/LetterSounds';
import './index.css';

function App() {
  const { i18n } = useTranslation();
  const { user, fetchProfile, token, authChecked } = useAuthStore();

  useEffect(() => {
    if (token) {
      fetchProfile();
    }
  }, [token, fetchProfile]);

  return (
    <Router>
      <div className="flex flex-col h-screen overflow-hidden">
        <Navbar />
        <div className="flex-1 min-h-0 overflow-y-auto bg-[#faf8f4] dark:bg-stone-950">
          {!authChecked ? (
            // a saved token exists but hasn't been verified yet — hold off on any route
            // guard's redirect until we actually know whether the user is signed in, so a
            // refresh on e.g. /write lands back on /write instead of bouncing through
            // /login and then home
            <div className="flex items-center justify-center h-full">
              <Loader2 size={28} className="animate-spin text-brand-600" />
            </div>
          ) : (
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/login"
                element={user ? <Navigate to="/" /> : <Login />}
              />
              <Route
                path="/register"
                element={user ? <Navigate to="/" /> : <Register />}
              />
              <Route
                path="/lessons"
                element={user ? <Lessons /> : <Navigate to="/login" />}
              />
              <Route
                path="/lessons/:id"
                element={user ? <LessonDetail /> : <Navigate to="/login" />}
              />
              <Route
                path="/profile"
                element={user ? <Profile /> : <Navigate to="/login" />}
              />
              <Route
                path="/write"
                element={user ? <LetterPractice /> : <Navigate to="/login" />}
              />
              <Route
                path="/listen"
                element={user ? <LetterSounds /> : <Navigate to="/login" />}
              />
            </Routes>
          )}
        </div>
      </div>
    </Router>
  );
}
export default App;
